import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as managerApi from '../apis/manager';

// 쿼리 키 상수화
export const MANAGER_KEYS = {
    all: ['managers'],
    groups: (userId) => [...MANAGER_KEYS.all, 'groups', userId],
};

/* ==========================================
    Queries (GET)
========================================== */

/**
 * 매니저 롤 그룹 매핑 조회
 * 
 * @param {string|number} userId - 매니저 사용자 ID
 */
export const useManagerGroups = (userId) => {
    return useQuery({
        queryKey: MANAGER_KEYS.groups(userId),
        queryFn: () => managerApi.getManagerGroups(userId),
        enabled: !!userId, // userId가 있을 때만 실행
    });
};

/* ==========================================
    Mutations (POST, PUT, PATCH, DELETE)
========================================== */

/**
 * 퍼실리테이터(FT) 또는 교육운영자(OP)를 여러 그룹에 매핑
 * 
 * @returns {Object} mutation 객체
 */
export const useMapUserToGroups = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ userId, groupIds }) => managerApi.mapUserToGroups(userId, groupIds),
        onSuccess: (data, variables) => {
            // 매니저 그룹 매핑 조회 쿼리 갱신
            queryClient.invalidateQueries({ queryKey: MANAGER_KEYS.groups(variables.userId) });
            // 필요하다면 사용자 목록도 갱신할 수 있음
            // queryClient.invalidateQueries({ queryKey: USER_KEYS.lists() });
        },
    });
};
